"use strict";

const NO_BOOK_ERROR_TEMPLATE = `
	<div class="col-lg-12 p40 error center">
		<header class="col-lg-12 p0">
			<img src="./assets/images/error/notfound.png" class="img-responsive center" />
				<h1><%= app.localeManager.get("errors.no_book") %></h1>
				<h3 class="less"><%= app.localeManager.get("errors.no_book_description") %></h3>
		</header>
	</div>`
;

// The view for a single book model
const NoBookErrorPage = Backbone.View.extend({
	// The created DOM element
	tagName : "section",

	// The classes for the DOM element
	className : "container mtop-40",

	// Convert the template into HTML
	template : _.template( NO_BOOK_ERROR_TEMPLATE ),

	// afterRender should be considered as an abstract method that every view must implement
	// in this very special case we do not want to do anything after the page was rendered
	afterRender: function() {
	},

	// Render the template
	render : function() {
		var errorTemplate = this.template(this.model);
		this.$el.html(errorTemplate);
		
		return this;
	}
});